export default async function startVideoRecording() {
  const iframeWrapper = document.getElementById('one-click-to-notion');
  const iframeElement = document.getElementById('my-iframe');

  let showTimer = true;

  const hide = () => {
    showTimer = false;
    iframeWrapper.style.display = 'block';
  };

  const hintElement = `
  <div id="notix-video-hint" class="notix-video-controls">
      <div style="display: flex; justify-content: center; align-items: center;">
        <button
            id="stop-button"
            class="notix-button"
        >
  <span class="c-icon">
    <i
      :style="style"
      class="_icon"
    >
<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="1" width="22" height="22" rx="2" fill="#DA5F57"/>
</svg>
    </i>
  </span>
        <div id="timer" class="timer">
        0:00
</div>
        </button>
        <div class="divider"></div>
        <button
            id="cancel-button"
            class="notix-button notix-icon-button"
        >
  <span class="c-icon">
    <i
      :style="style"
      class="_icon"
    >
<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.6487 12L21.9397 2.40184C22.0787 2.24233 21.9618 2 21.7471 2H19.2266C19.0782 2 18.936 2.06442 18.8381 2.17485L12 10.092L5.16189 2.17485C5.06714 2.06442 4.92501 2 4.7734 2H2.25293C2.03815 2 1.92129 2.24233 2.06026 2.40184L10.3513 12L2.06026 21.5982C2.02913 21.6337 2.00916 21.6772 2.00272 21.7234C1.99628 21.7697 2.00363 21.8168 2.02392 21.8591C2.04421 21.9014 2.07657 21.9372 2.11716 21.9621C2.15775 21.9871 2.20488 22.0003 2.25293 22H4.7734C4.92185 22 5.06398 21.9356 5.16189 21.8251L12 13.908L18.8381 21.8251C18.9329 21.9356 19.075 22 19.2266 22H21.7471C21.9618 22 22.0787 21.7577 21.9397 21.5982L13.6487 12Z" fill="white"/>
</svg>
    </i>
  </span>
        </button>
      </div>
  </div>
`;


  const updateTimer = (startTime) => () => {
    const d = new Date();
    const diff = (d.getTime() - startTime.getTime()) / 1000;

    const timer = document.getElementById('timer');
    timer.innerHTML = formatDuration(Math.round(diff));
    if (showTimer) {
      setTimeout(updateTimer(startTime), 1000);
    }
  };

  style();

  iframeWrapper.style.display = 'none';

  const template = document.createElement('template');
  template.innerHTML = hintElement.trim();
  const tooltip = template.content.childNodes[0];

  let data = [];
  let recorder;
  let cancelled = false;

  navigator.mediaDevices.getDisplayMedia({
    video: { mediaSource: 'screen' },
    audio: true,
  })
    .then(async (e) => {
      cancelled = false;

      const audio = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });

      const combine = new MediaStream(
        [...e.getTracks(), ...audio.getTracks()],
      );

      recorder = new MediaRecorder(combine);
      data = [];
      recorder.start();

      document.body.appendChild(tooltip);
      const handleCancelClick = () => {
        cancelled = true;
        recorder.stop();
        recorder.stream.getTracks()
          .forEach((track) => track.stop());
        tooltip.remove();
        hide();
      };

      const cancelButton = document.getElementById('cancel-button');
      cancelButton.addEventListener('click', handleCancelClick);

      const handleStopClick = () => {
        recorder.stop();
        recorder.stream.getTracks()
          .forEach((track) => track.stop());
        tooltip.remove();
        hide();
      };

      const stopButton = document.getElementById('stop-button');
      stopButton.addEventListener('click', handleStopClick);

      const startTime = new Date();
      setTimeout(updateTimer(startTime), 1000);

      recorder.ondataavailable = (e) => {
        data.push(e.data);
      };

      recorder.onstop = () => {
        if (!cancelled) {
          const blobData = new Blob(data, { type: 'video/mp4' });

          const blobToBase64 = (blob) => new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });
          blobToBase64(blobData).then((res) => {
            iframeElement.contentWindow.postMessage({ msg: 'NOTIX_ADD_VIDEO', src: res }, '*');
          });
        }
        data = [];
      };
    });
}

const style = () => {
  function addStyle(styleString) {
    const style = document.createElement('style');
    style.type = 'text/css';
    style.textContent = styleString;
    document.head.append(style);
  }
  addStyle(`
  .notix-video-controls {
    z-index: 99999999;
    border-radius: 4rem;
    position: fixed;
    bottom: 2rem;
    left: 2rem; 
    padding: .6rem .8rem; 
    background: black; 
    color: rgb(189, 189, 189); 
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, SF Pro Display, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  }
  
  .notix-button {
    border: none;
    cursor: pointer;
    padding: .4rem 1rem;
    border-radius: 1.5rem; 
    background: transparent;
    height: 3rem;
    font-size: 1.6rem;
    display: flex;
    align-items: center;
  }
  
  .notix-icon-button {
    padding: .4rem .8rem;
    width: 3rem;
    font-size: 1.3rem;
  }
  
  .notix-button:hover {
    background: #565656;
  }
  
  .c-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .c-icon > ._icon {
      display: inline-block;
      font-style: normal;
      line-height: 0;
      text-align: center;
      text-transform: none;
      vertical-align: -.125em;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
   }
   
  .timer {
    font-weight: bold; 
    font-size: 16px;
    margin-left: 10px;
    width: 36px;
    color: white;
    margin-top: 0.1rem;
  }
  
  .divider {
    height: 20px;
    width: 1px;
    background: #565656;
    margin: 0 6px;
  }
`);
};
